import React, { useEffect, useState } from "react";
import { pdf } from "@react-pdf/renderer";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Invoice from "./client/invoice/components/reports/Invoice";
import CardBox from "components/ui/controls/card-box/card-box";
import { User } from "components/app/Api/ApiUser";
import { FaDownload, FaExclamationTriangle, FaFileInvoice, FaFilePdf } from "react-icons/fa";
import { saveAs } from "file-saver";
import "components/app/AuditComplet/ContexteFiscal/ContexteFiscal.css";
import Button from "components/ui/controls/button/button";
import { createStyledButton } from "components/ui/controls/button/button-styles";

const generatePdfDocument = async (documentData) => {
  console.log(documentData);
  const blob = await pdf(<Invoice invoice={documentData} />).toBlob();
  saveAs(blob, documentData.number + " " + documentData.date);
};

const InvoicesPage = (props) => {
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    User({}, "GetInvoices").then((Invoices) => {
      setInvoices(Invoices);
    });
  }, []);
  return (
    <Column scroll fill>
      <CardBox>
        <Column fill>
          <Row>
            <div className="revenuspro-container">
              {/* Header séparé */}
              <div className="header-card">
                <div className="category-column" style={{ textAlign: "center", maxWidth: "120px" }}>
                  <FaFileInvoice className="header-icon" />
                  Date
                </div>
                <div className="value-column" style={{ textAlign: "center" }}>
                  Numéro
                </div>
                <div className="value-column" style={{ textAlign: "center" }}>
                  Statut
                </div>
                <div className="value-column" style={{ textAlign: "center" }}>
                  Actions
                </div>
              </div>
              {/* Conteneur des cartes de contenu */}
              <div className="card-list-container">
                {invoices.map((Infos, index) => (
                  <div key={"invoices" + index} className="card">
                    <div className="category-column" style={{ maxWidth: "120px" }}>
                      <span className="trimester-year-badge" style={{ minWidth: "80px" }}>
                        {Infos.date}
                      </span>
                    </div>
                    <div className="value-column">{Infos.number}</div>
                    <div className="value-column">
                      <span
                        style={{
                          color: !Infos.paid_invoice_pdf ? "#ef4444" : "#10b981",
                          fontWeight: "500",
                          fontSize: "12px",
                        }}
                      >
                        {!Infos.paid_invoice_pdf ? "En attente de paiement" : "Payée"}
                      </span>
                    </div>
                    <div className="value-column">
                      {Infos.number.substr(0, 1) === "F" && (
                        <>
                          {!Infos.paid_invoice_pdf ? (
                            <Button icon {...createStyledButton("card-action", "delete")}>
                              <FaExclamationTriangle style={{ color: "#ef4444" }} />
                            </Button>
                          ) : (
                            <a style={{ color: "var(--app-selected-bg-color)", textDecoration: "none" }} target="_blank" href={Infos.customer_portal_url} rel="noopener noreferrer">
                              <Button icon {...createStyledButton("card-action", "download")}>
                                <FaDownload style={{ fontSize: "12px", color: "#8b5cf6" }} />
                              </Button>
                            </a>
                          )}
                        </>
                      )}
                      {Infos.number.substr(0, 1) !== "F" && (
                        <>
                          {!Infos.paid_invoice_pdf ? (
                            <Button icon {...createStyledButton("card-action", "delete")}>
                              <FaExclamationTriangle style={{ color: "#ef4444" }} />
                            </Button>
                          ) : (
                            <Button icon {...createStyledButton("card-action", "download")}>
                              <FaDownload
                                onClick={() => {
                                  generatePdfDocument(Infos);
                                }}
                                style={{ fontSize: "12px", color: "#8b5cf6" }}
                              />
                            </Button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Row>
        </Column>
      </CardBox>
    </Column>
  );
};

export default InvoicesPage;
